import { useState } from "react";
import "../Main.css";
import "../css/fontawesome-5.14.0.min.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// import { Flag } from "semantic-ui-react";

// type LanguageOption = {
//   value: string;
//   label: JSX.Element;
// };

const HomeMenu = () => {
  const [isHover, setIsHover] = useState({
    home: false,
    services: false,
    project: false,
    pages: false,
    shop: false,
    blog: false,
    multiplepage: false,
    onepage: false,
    team: false,
  });
  const handleMouseEnter = (item: any) => {
    setIsHover((prevState) => ({
      ...prevState,
      [item]: true,
    }));
  };

  const handleMouseLeave = (item: any) => {
    setIsHover((prevState) => ({
      ...prevState,
      [item]: false,
    }));
  };

  // const { i18n } = useTranslation();
  const { t } = useTranslation();

  // const languages: LanguageOption[] = [
  //   {
  //     value: "en",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="vg" /> En
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "az",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="az" /> Az
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "ar",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="ae" /> Ae
  //       </div>
  //     ),
  //   },
  //   {
  //     value: "ru",
  //     label: (
  //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
  //         <Flag name="ru" /> Ru
  //       </div>
  //     ),
  //   },
  // ];

  // const [activeLang, setActiveLang] = useState<LanguageOption>(languages[0]);

  // const handleLangChange = (selectedOption: any) => {
  //   setActiveLang(selectedOption);
  //   i18n.changeLanguage(selectedOption.value);
  // };

  return (
    <>
      <ul className="navigation clearfix">
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("home")}
          onMouseLeave={() => handleMouseLeave("home")}
        >
          <Link to="/" style={{ color: "#fff" }}>
            {t("navHome")}
          </Link>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("services")}
          onMouseLeave={() => handleMouseLeave("services")}
        >
          <a href="/" style={{ color: "#fff" }}>
            {t("navServices")}
          </a>
          <ul style={{ display: `${isHover.services ? "block" : "none"}` }}>
            <li>
              <Link to="/web-development">{t("navServicesSub1")}</Link>
            </li>
            <li>
              <Link to="/mobile-app-development">{t("navServicesSub2")}</Link>
            </li>
            <li>
              <Link to="/software-development">{t("navServicesSub3")}</Link>
            </li>
            <li>
              <Link to="/dev-ops">{t("navServicesSub4")}</Link>
            </li>
            <li>
              <Link to="/cloud-computing">{t("navServicesSub5")}</Link>
            </li>
            <li>
              <Link to="/digital-marketing">{t("navServicesSub6")}</Link>
            </li>
          </ul>
          <div className="dropdown-btn">
            <span className="fas fa-chevron-down" style={{ color: "#fff" }} />
          </div>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("project")}
          onMouseLeave={() => handleMouseLeave("project")}
        >
          <Link to="/projects" style={{ color: "#fff" }}>
            {t("navProject")}
          </Link>
        </li>
        <li
          className="dropdown"
          onMouseEnter={() => handleMouseEnter("pages")}
          onMouseLeave={() => handleMouseLeave("pages")}
        >
          <Link to="/about-us" style={{ color: "#fff" }}>
            {t("navAbout")}
          </Link>
        </li>
        <li>
          <Link to="/press-release" style={{ color: "#fff" }}> Press-Release</Link>
        </li>
        
         <li>
          <Link to="/blogs" style={{ color: "#fff" }}>
           Blogs
          </Link>
        </li>
        <li>
          <Link to="/contact-us" style={{ color: "#fff" }}>
            {t("navContact")}
          </Link>
        </li>
          
       
        {/* <div className="d-flex justify-content-center align-items-center">
          <Select
            value={activeLang}
            onChange={handleLangChange}
            options={languages}
            isSearchable={false}
          />
        </div> */}
      </ul>
    </>
  );
};

export default HomeMenu;
